/** Strips spaces and hyphens and upper-cases a trailing X. */
export function normalizeIsbn(value: string): string {
  return value.replace(/[\s-]+/g, '').toUpperCase()
}

/** ISBN-10 (mod 11, X = 10) or ISBN-13 (EAN mod 10) checksum validation. */
export function isValidIsbn(value: string): boolean {
  const v = normalizeIsbn(value)
  if (/^\d{9}[\dX]$/.test(v)) {
    let sum = 0
    for (let i = 0; i < 10; i++) {
      const c = v[i] ?? '0'
      sum += (c === 'X' ? 10 : Number(c)) * (10 - i)
    }
    return sum % 11 === 0
  }
  if (/^\d{13}$/.test(v)) {
    let sum = 0
    for (let i = 0; i < 13; i++) sum += Number(v[i]) * (i % 2 === 0 ? 1 : 3)
    return sum % 10 === 0
  }
  return false
}

/** 9780306406157 → 978-0-306-40615-7 style grouping is publisher-specific; we only split the prefix and check digit. */
export function formatIsbn(value: string | null): string {
  if (!value) return '—'
  if (value.length === 13) return `${value.slice(0, 3)}-${value.slice(3, 12)}-${value.slice(12)}`
  if (value.length === 10) return `${value.slice(0, 9)}-${value.slice(9)}`
  return value
}
